import React from "react";
import UpdateTariffModal, {
  Benefits,
  MembershipCard,
  UpdateTariffModalProps,
} from "./UpdateTariffModal";
import { CircularProgress } from "@mui/material";

interface DowngradeModalProps extends Omit<UpdateTariffModalProps, "children"> {
  closeModal: () => void;
  downgrade: (membershipId: number) => void;
  pending?: boolean;
}

const DowngradeModal = ({
  isVisible,
  closeModal,
  downgrade,
  pending,
}: DowngradeModalProps) => {
  return (
    <UpdateTariffModal isVisible={isVisible}>
      <h2>Are you sure you want to downgrade?</h2>
      <h3>
        By downgrading to the Monthly Membership, you will{" "}
        <span className="strong">lose access to</span>
      </h3>
      <Benefits
        benefits={[
          { text: "Pre Baby Bootcamp", positive: false },
          { text: "Mom Survival Group", positive: false },
          {
            text: "Group Infant and Child CPR with First Aid",
            positive: false,
          },
          { text: "Group Sleep Consult", positive: false },
        ]}
      />
      <MembershipCard
        title="Monthly Membership"
        price="$149"
        priceSumDescription="Renews monthly, cancel any time."
        type="red"
      />
      <div className="updateTariffModalButtons">
        <button
          className="btn primary-blue-small-btn-40 updateTariffModalButtons__confirm"
          onClick={() => downgrade(1)}
        >
          {pending ? <CircularProgress size={16} /> : "Confirm Downgrade"}
        </button>
        <button
          className="btn primary-blue-small-btn-40 updateTariffModalButtons__close"
          onClick={closeModal}
        >
          Keep Annual Membership
        </button>
      </div>
    </UpdateTariffModal>
  );
};

export default DowngradeModal;
